export default {
  primary: {
    color: 'light',
    border: 'solid 1px',
    fontSize: '0.7rem',
    fontWeight: '700',
    textTransform: 'uppercase',
    paddingBottom: '0rem',
    padding: '1rem 3rem',
    borderColor: 'light',
    backgroundColor: 'secondary',
    ':hover': {
      backgroundColor: 'transparent',
      color: 'light'
    }
  },
  secondary: {
    backgroundColor: 'secondary',
    padding: '0.75rem 2rem',
    color: 'text',
    border: 'none',
    border: 'solid 2px',
    borderColor: 'secondary',
    borderRadius: '0px',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    // WebkitTextStroke: '0.5px #487035',
    display: 'flex',
    fontSize: '1rem',
    transition: 'all ease-in-out 0.8s',
    ':hover': {
      // opacity: '0.4',
      backgroundColor: 'transparent',
      color: 'light'
    }
  }
}
